import * as React from "react";
import { Icon } from "sb-resp-ui";
import { filterItemTypeMap, sportItemType } from "../../../../common";
import { CarouselItemProps } from "..";
import { DeviceDetect } from "sb-resp-lib";
import { observer } from "mobx-react";
import { SportModel } from "../../../../modes";

@observer
export class SportsCarouselItem extends React.Component<CarouselItemProps<SportModel>>
{
    private deviceDetect: DeviceDetect;

    constructor(props) {
        super(props);
        this.deviceDetect = DeviceDetect.getInstance();
    }

    private getIcon(sport: SportModel) {
        const iconClass = this.iconClassGenerator[sport.type](sport);
        return iconClass + this.getIconSize();
    }

    private iconClassGenerator: filterItemTypeMap<(sport: SportModel) => string, sportItemType> = {
        sports: (sport) => (this.props.config.alternative ? "i-o-sport-alt-" : (this.props.config.colorful ? "i-c-sport-" : "i-o-sport-")) + sport.id,
        allSports: (_) => (this.props.config.colorful ? "i-c-" : "i-o-") + "qnav-all-sports",
        favorites: (_) => (this.props.config.colorful ? "i-c-" : "i-o-") + "qnav-fav",
        liveStream: (_) => (this.props.config.colorful ? "i-c-" : "i-o-") + "qnav-ls"
    }

    private getIconSize() {
        return " i-" + (this.props.config.iconSize ? this.props.config.iconSize : "32");
    }

    render() {
        const itemClass = "rj-carousel-item" + (this.props.isSelected ? " rj-carousel-item--active" : "");
        return (
            <div className={itemClass} onClick={this.props.handler} data-uat="carousel-item-sport">
                {((this.deviceDetect.isDesktop || !this.props.config.hideSportIconOnMobile)
                    ? <Icon i={this.getIcon(this.props.item)} /> : "")}
                <div className="rj-carousel-item__details">
                    <div className="rj-carousel-item__sportName" data-uat="carousel-item-sportName">
                        {this.props.item.name}
                    </div>
                    <div className="rj-carousel-item__eventsCount" data-uat="carousel-item-eventsCount">
                        {this.props.item.numberOfEvents}
                    </div>
                </div>
            </div>
        )
    }
}